export default __webpack_public_path__ + "static/media/noah-wetering.a2638125.jpg";